import CardTemplateSettings from './CardTemplateSettings';

export default CardTemplateSettings;
